import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navbar, Nav, Dropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom'
import layoutHelpers from './helpers';

class LayoutNavbar extends Component {
  constructor(props) {
    super(props);
    this.isRTL = document.documentElement.getAttribute('dir') === 'rtl';
    this.state = {
      navbarSearchExpanded: false,
      claims: {
        firstname: "",
        lastname: ""
      }
    };
  }

  componentDidMount(){
    let session = localStorage.getItem("session")
    if(session !== null){
      session = JSON.parse(session)
      if(session.claims !== null){
        this.setState({
          ...this.state,
          claims: session.claims
        })
      }
      
    }
  } 

  toggleSidenav = e => {
    e.preventDefault();
    layoutHelpers.toggleCollapsed();
  }

  logOut = () => {
    this.props.history.push('/logout')
  }

  render() {
    return (
      <Navbar bg={this.props.navbarBg} expand='sm' className='layout-navbar align-items-sm-center container-p-x'>
         {/* Sidenav toggle */}
         {(this.props.sidenavToggle && !this.props.children.props.sidenavBack) && (
          <Nav className='align-items-lg-center mr-auto mr-lg-4'>
            <Nav.Item as='a' className='nav-item nav-link px-0 ml-2 ml-lg-0' href='#toggle' onClick={this.toggleSidenav}>
              <i className='ion ion-md-menu text-large align-middle' />
            </Nav.Item>
          </Nav>
        )}
        
        {/* Sidenav back */}
        {this.props.children.props.sidenavBack && (
          <Nav className='align-items-lg-center mr-auto mr-lg-4'>
            <Nav.Item as='a' className='nav-item nav-link px-0 ml-2 ml-lg-0' href='#toggle' onClick={this.props.history.goBack}>
              <i className='ion ion-md-arrow-back text-large align-middle' />
            </Nav.Item>
          </Nav>
        )}

        <Navbar.Brand as={NavLink} to="/" className="app-brand d-sm-none py-0 mr-4">
          <span className="app-brand-logo">
            <img alt="" src="/img/Logos/gecko_blanco.svg" className="h-50 position-absolute"/>
          </span>
          {/* <span className="app-brand-text font-weight-normal ml-2">Gecko Visions</span> */}
        </Navbar.Brand>

        <Navbar.Collapse>
            <Nav className="align-items-sm-center ml-auto">
              <Dropdown as={Nav.Item} className="navbar-user" alignRight={!this.isRTL}>
                <Dropdown.Toggle as={Nav.Link}>
                  <span className="d-inline-flex flex-sm-row-reverse align-items-center align-middle">
                    <span className="px-1 mr-sm-2 ml-2 ml-sm-0">{ `${this.state.claims.firstname} ${this.state.claims.lastname}` }</span>
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={this.logOut}>
                    <i className="ion ion-ios-log-out text-danger"></i> &nbsp; Cerrar Sesión
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

LayoutNavbar.propTypes = {
  sidenavToggle: PropTypes.bool
};

LayoutNavbar.defaultProps = {
  sidenavToggle: true
};

export default connect((store) => ({
  navbarBg: store.theme.navbarBg,
}))(LayoutNavbar);
